import React, { ComponentProps } from 'react';
import Img from 'react-cool-img';
import styled from 'styled-components';
import { Link } from 'react-router-dom-v5';
import { Row, Column } from 'spw-shared/globalComponents';
import { colors } from 'spw-theme';
import UserAvatar from 'spw-components/collab/user-avatar';

export const HEADER_HEIGHT_IN_PX = 52;

export const StickyHeaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1300;
  box-shadow: 0px 0px 5px #80808080;
  background-color: ${colors.white};
`;

export const HeaderBox = styled(Row)`
  height: ${HEADER_HEIGHT_IN_PX}px;
  align-items: center;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
`;

export const HeaderAppTitle = styled(Column)`
  font-family: Avenir;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 52px;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: flex;

  img {
    width: 220px;
    margin-right: 30px;
  }
`;

export const HeaderAvatar = styled(
  (props: ComponentProps<typeof UserAvatar>) => {
    return <UserAvatar {...props} />;
  }
)`
  && {
    border-radius: 4px;
    cursor: pointer;
    height: 40px;
    width: 40px;
    box-sizing: border-box;
    margin-left: 12px;
  }
`;

export const HelpButton = styled(Img)`
  border-radius: 50%;
  cursor: pointer;
  height: 24px;

  &.pressed {
    background: #eee;
  }
`;

export const NewHelpButton = styled(HelpButton)`
  margin-left: 12px;
`;

export const Gradient = styled(Row)`
  width: 100%;
  height: 32px;
  background: linear-gradient(
    180deg,
    rgba(11, 149, 178, 0.7) 0%,
    #78e4d4 13.02%,
    #d8fff1 68.23%,
    rgba(216, 255, 241, 0) 100%
  );
`;

export const MenuColumn = styled(Column)`
  && {
    min-width: 185px;
    background: #ffffff;
    padding-top: 8px;
    padding-bottom: 8px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.11);
    border-radius: 5px;

    & > div {
      height: 22px;
      line-height: 22px;
    }
  }
`;

export const EmailRow = styled(Row)`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  display: flex;
  align-items: center;
  flex: 1;
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 8px;
`;

export const LogoutRow = styled(Row)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  color: #00819e;
  flex: 1;
  padding-left: 15px;
`;

export const LogoutText = styled.span`
  cursor: pointer;
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const SpacePlanWizardLogo = styled(Img)`
  border-radius: 4px;
  height: 38px;
  margin-right: 16px;
  width: 38px;
`;

export const SpacePlanWizardTextLogo = styled(Img)`
  width: 180px;
  height: 14px;
`;

export const LinksWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-right: 24px;
`;

export const LinkStyled = styled(Link)`
  && {
    align-items: center;
    border-radius: 4px;
    box-sizing: border-box;
    color: ${colors.fontColor};
    display: flex;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    height: 33px;
    justify-content: center;
    line-height: 24px;
    padding: 0 12px;
    text-align: center;
    text-transform: uppercase;
    white-space: nowrap;

    .content {
      margin-top: 1px;
    }
  }

  &.active {
    border: 1px solid ${colors.veryLightGray};
    color: ${colors.black};
    font-weight: 500;
  }

  &.active,
  &:hover {
    background-color: ${colors.lightGreyBackground};
  }
`;

export const HelpMenuItem = styled.div`
  padding: 8px 16px;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
`;

export const AnnouncementsCard = styled(Column)`
  width: 400px;
  overflow-y: hidden;
  color: ${colors.black};

  .title {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;

    padding: 16px 12px 16px 24px;
    display: flex;
    justify-content: space-between;
  }

  .content {
    max-height: 661px;
    padding-bottom: 12px;
    overflow-y: overlay;
    box-sizing: border-box;
  }

  .release-group {
    padding: 0 24px;

    .release-group-title {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      text-transform: uppercase;
      padding: 16px 0;
    }
  }

  .release-card {
    padding: 16px 15px 10px 15px;
    border: 1px solid ${colors.veryLightGray};
    border-radius: 8px;
    margin-bottom: 8px;

    .release-card-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 8px;
    }

    ul {
      margin: 0;
      padding-left: 24px;

      li {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;
